import { styled as muiStyled } from '@mui/material'
import ReactShowMoreText from 'react-show-more-text'

export const APPhaseShowMoreText = muiStyled(ReactShowMoreText)(
  ({ theme }) => `
  font-size: 14px;
  font-weight: 300;
  margin: 0;
  width: 100%;
  .show-more-less-clickable {
    font-weight: 500;
  }
`,
)
